
const SkeletonLoading = () => {
  return (
    <div className="max-w-7xl mx-auto p-6 animate-pulse">
      {/* Botón de retroceso */}
      <div className="mb-6 h-6 bg-gray-100 rounded-full w-32"></div>

      {/* Header Section */}
      <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 mb-6">
        <div className="flex flex-col md:flex-row gap-6">
          {/* Imagen */}
          <div className="w-full md:w-1/3 h-64 bg-gray-100 rounded-xl"></div>
          
          <div className="flex-1 space-y-4">
            <div className="flex justify-between items-start">
              <div className="h-8 bg-gray-100 rounded-full w-2/3"></div>
              <div className="h-6 bg-gray-100 rounded-full w-20"></div>
            </div>
            
            <div className="space-y-2">
              <div className="h-4 bg-gray-100 rounded-full w-full"></div>
              <div className="h-4 bg-gray-100 rounded-full w-5/6"></div>
              <div className="h-4 bg-gray-100 rounded-full w-3/4"></div>
            </div>
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="h-20 bg-gray-100 rounded-xl"></div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Main Grid */}
      <div className="grid lg:grid-cols-3 gap-6">
        {/* Left Column */}
        <div className="lg:col-span-2 space-y-6">
          {/* Performance Metrics */}
          <div className="bg-white p-6 rounded-2xl border border-gray-100">
            <div className="h-6 bg-gray-100 rounded-full w-1/3 mb-4"></div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="h-20 bg-gray-100 rounded-xl"></div>
              ))}
              <div className="col-span-full space-y-2">
                <div className="h-4 bg-gray-100 rounded-full w-1/4"></div>
                <div className="w-full bg-gray-100 rounded-full h-2"></div>
              </div>
            </div>
          </div>

          {/* Click Analytics */}
          <div className="bg-white p-6 rounded-2xl border border-gray-100">
            <div className="h-6 bg-gray-100 rounded-full w-1/3 mb-4"></div>
            <div className="grid md:grid-cols-2 gap-4">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="space-y-2">
                  <div className="h-4 bg-gray-100 rounded-full w-1/3"></div>
                  <div className="h-4 bg-gray-100 rounded-full w-2/3"></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="space-y-6">
          {/* Campaign Dates */}
          <div className="bg-white p-6 rounded-2xl border border-gray-100">
            <div className="h-6 bg-gray-100 rounded-full w-1/3 mb-4"></div>
            <div className="space-y-3">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="flex justify-between">
                  <div className="h-4 bg-gray-100 rounded-full w-1/4"></div>
                  <div className="h-4 bg-gray-100 rounded-full w-1/3"></div>
                </div>
              ))}
            </div>
          </div>

          {/* Targeting */}
          <div className="bg-white p-6 rounded-2xl border border-gray-100">
            <div className="h-6 bg-gray-100 rounded-full w-1/3 mb-4"></div>
            <div className="space-y-3">
              <div className="h-4 bg-gray-100 rounded-full w-1/4"></div>
              <div className="flex flex-wrap gap-2">
                {[...Array(3)].map((_, i) => (
                  <div key={i} className="h-6 bg-gray-100 rounded-md w-16"></div>
                ))}
              </div>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="bg-white p-6 rounded-2xl border border-gray-100">
            <div className="h-6 bg-gray-100 rounded-full w-1/3 mb-4"></div>
            <div className="space-y-3">
              {[...Array(2)].map((_, i) => (
                <div key={i} className="h-12 bg-gray-100 rounded-xl"></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Componente reutilizable para elementos skeleton
export const Skeleton = ({ height = 'h-4', width = 'w-full' }) => (
  <div className={`${height} ${width} bg-gray-100 rounded-full animate-pulse`}></div>
);

export default SkeletonLoading;